import TypicalAchievementsCard from "./TypicalAchievementsCard";
import eCommerceImg from "../assets/images/projects/1.jpg";
import carWashImg from "../assets/images/projects/2.jpg";
import rentACarImg from "../assets/images/projects/3.jpg";
import eLearningImg from "../assets/images/projects/4.jpg";
import hotelBookingImg from "../assets/images/projects/5.jpg";
import evStationImg from "../assets/images/projects/6.jpg";
import comissioningImg from "../assets/images/projects/7.jpg";
import pipelineImg from "../assets/images/projects/8.jpg";

const TypicalAchievements = () => {
  const services = [
    { name: "Smart Site", imageUrl: evStationImg, path: "/site-management" },
    { name: "Smart Camp", imageUrl: hotelBookingImg, path: "/construction-management" },
    { name: "Spool E-Fabrication", imageUrl: eCommerceImg, path: "/pipe-prefabrication" },
    { name: "Expediting & Logistics", imageUrl: eLearningImg, path: "/logistics-management" },
    { name: "Material Management", imageUrl: carWashImg, path: "/warehousing-materials" },
    { name: "Smart Spool", imageUrl: rentACarImg, path: "/smart-spool" },
    { name: "Comissioning & Pre-Commissioning", imageUrl: comissioningImg, path: "/completion-system" },
    { name: "Pipeline Management", imageUrl: pipelineImg, path: "/" },
  ];

  return (
    <section className="py-10 px-5 md:mt-10 w-full">
      <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center">
        Typical achievements <span className="text-orange-500">we have made</span>
      </h2>

      {/* Full Width Grid */}
      <div className="w-full mt-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <div key={index} className="flex justify-center">
              <TypicalAchievementsCard service={service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TypicalAchievements;